import api from "../../../axiosConfig";

export const emailCampaignsApi = {
  create: async (payload) => {
    const res = await api.post("/email/campaigns", payload);
    return res.data;
  },

  // Server-rendered exact preview: runs the same renderer + signature builder as
  // the live send, so the returned HTML equals what the recipient receives.
  // Returns { html, signature_source: 'personal' | 'company' | 'text' | 'none' }.
  preview: async ({ subject = "", body_html }) => {
    const res = await api.post("/email/campaigns/preview", { subject, body_html });
    return res.data;
  },

  status: async ({ campaignId, perPage = 200, page = 1 }) => {
    const res = await api.get(`/email/campaigns/${campaignId}/recipients?per_page=${perPage}&page=${page}`);
    return res.data;
  },

  checkSpamSafety: async ({ emails, days, subject = "", body_html = "" }) => {
    const res = await api.post("/email/check-spam-safety", { emails, days, subject, body_html });
    return res.data; // { safeEmails, excludedCount, ... }
  },

  draftWithAi: async ({ brief, audience_name = "", audience_count = 0, reply_to_email = "" }) => {
    const res = await api.post("/email/campaigns/draft-ai", {
      brief,
      audience_name,
      audience_count,
      reply_to_email,
    });
    return res.data;
  },

  seasonalOccasions: async () => {
    const res = await api.get("/email/seasonal/occasions");
    return res.data;
  },

  seasonalDraft: async ({ occasion_key, custom_brief = "" }) => {
    const res = await api.post("/email/seasonal/draft", { occasion_key, custom_brief });
    return res.data;
  },
};
